<template>
  <div class="hearingAidSales__top-product">
    <div class="grid">
      <div class="grid__col--6 mix__chart mix__chart--mfg">
        <div class="hearingAidSales__mix--mfg chart">
          <div class="chart__wrapper">
            <h3>TOP PRODUCTS</h3>
            <Products :products="top1" :index-offset="1"></Products>
          </div>
        </div> <!-- END chart block -->
      </div>

      <div class="grid__col--6 mix__chart mix__chart--mfg">
        <div class="hearingAidSales__mix--mfg chart">
          <div class="chart__wrapper">
            <h3>&nbsp;</h3>
            <Products :products="top2" :index-offset="9"></Products>
          </div>
        </div> <!-- END chart block -->
      </div>
    </div> <!-- end grid -->
  </div>
</template>



<script>
  import lodash from 'lodash';
  import Products from './Products.vue';

  export default {
    name: 'TopProducts',
    components: {
      Products,
    },
    props: ['formattedData', 'showTrend'],
    computed: {
      top1() {
        return lodash.isArray(this.formattedData) ? this.formattedData.slice(0, 8) : [];
      },
      top2() {
        return lodash.isArray(this.formattedData) ? this.formattedData.slice(8, 16) : [];
      },
    },
  }
</script>



<style lang="scss" scoped>
  .mix {
    @include e('chart') {
      h3 {
        font-weight: 600;
        font-size: em(20px);
      }
    }
  }
  .chart {
    @include e('wrapper') {
      padding: 15px 0px 15px 15px;

      h3 {
        font-family: $font-family--secondary;
        color: $east-bay;
        font-size: em(16px);
        margin-bottom: 18px;
      }
    }
  }
</style>
